import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../types"
import { uniqueId } from "lodash"

const Svg = styled.svg`
  height: 41px;
  width: 41px;
`

export const Pause: AppFunctionComponent = ({ className }) => {
  const id = uniqueId()
  return (
    <Svg
      data-testid="audio-pause"
      className={className}
      role="img"
      aria-labelledby={id}
    >
      <title id={id}>{"Pause ringtone"}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-237.000000, -735.000000)" fill="#FFFFFF">
          <g transform="translate(191.000000, 516.000000)">
            <g transform="translate(46.000000, 219.000000)">
              <circle
                className="play-circle"
                opacity="0.100000001"
                cx="20.5"
                cy="20.5"
                r="20.5"
              />
              <g transform="translate(15.500000, 13.000000)">
                <rect x="8" y="0" width="2" height="15" rx="1" />
                <rect x="0" y="0" width="2" height="15" rx="1" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  )
}
